<template>
  <div class="main_container">
    <van-nav-bar
	  :title="$route.params.name"
	  left-text="返回"
	  left-arrow
    :fixed="true"
	  @click-left="onClickLeft"
	/>

  <iframe :src="$route.params.site" width="100%" height="95%" style="margin-top: 46px;border: none;"></iframe>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      title:''
    }
  },
  mounted(){
    var route_name = this.$route.params.site
    var title
    console.log(route_name)
  },
  methods: {
    onClickLeft() {
      this.$router.push({name:'mainFunc'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_container{
  height: 100%
}
</style>



// WEBPACK FOOTER //
// src/pages/application/pageIn.vue